import React from "react";
import { useNotesDispositions } from "../../../../common/services/dispositionServices";
import {
  Box,
  CircularProgress,
  TextField,
  Typography,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { getTheme } from "../../../../common/getLocalTheme";
import { ErrorMessage } from "../../../../common/ErrorMessage";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    width: "100%",
  },
  sectionTitle: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#64748b",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
  },
  autocompleteInput: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#ffffff",
      paddingTop: "2px !important",
      paddingBottom: "2px !important",
      "& fieldset": {
        borderColor: "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#cbd5e1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8b5cf6",
        borderWidth: "1.5px",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "6px 8px",
      fontSize: "0.875rem",
      color: "#1e293b",
    },
  },
}));



export const DispositionSection = ({
  disposition,
  setDisposition,
}:any) => {
  const classes = useStyles();
  const {
    error: errorDispositions,
    data: dispositions,
    isLoading: isLoadingDispositions,
    isError: isErrorDispositions,
  } = useNotesDispositions();

  const handleChange = (selectedDisposition: any | null) => {
    setDisposition(selectedDisposition);
  };

  if (isLoadingDispositions) {
    return (
      <Box className={classes.container}>
        <Typography className={classes.sectionTitle}>Status</Typography>
        <CircularProgress size={20} style={{ color: "#8b5cf6" }} />
      </Box>
    );
  }

  if (isErrorDispositions) {
    return <ErrorMessage error={errorDispositions} />;
  }

  const selectedValue =
    dispositions?.find((item: any) => item.id === disposition?.id) ||
    disposition ||
    null;

  return (
    <Box className={classes.container}>
      

      <Autocomplete
        id="status-disposition-select"
        options={dispositions || []}
        getOptionLabel={(option: any) => option.name || ""}
        value={selectedValue}
        onChange={(_, newValue) => handleChange(newValue)}
        disabled={getTheme()}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Status"
            variant="outlined"
            className={classes.autocompleteInput}
            data-testid="historicUser"
          />
        )}
      />
    </Box>
  );
};